import axios, { Canceler } from 'axios'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import {
  IAccountDailyAverageViewsResp,
  IAccountCountriesViewsResp,
  IAccountDashboardProductsViewsResp,
  IAccountProductsViewsResp,
  IAccountProductViewsResp,
  IAccountImpactsLikesResp,
  IAccountImpactLikesResp,
  IAccountTopItemsResp,
} from 'src/types'

class AccountsDashboardService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getViews(accountId: string, timeframe: number) {
    if (this.cancel) {
      this.cancel()
    }

    return this.get<IAccountDashboardProductsViewsResp>(`accounts-dashboard/views/${accountId}`, {
      params: {
        timeframe,
      },
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  getDailyAverageViews(accountId: string, timeframe: number) {
    return this.get<IAccountDailyAverageViewsResp>(`accounts-dashboard/views/${accountId}/total`, {
      params: {
        timeframe,
      },
    })
  }

  getCountriesViews(accountId: string) {
    return this.get<IAccountCountriesViewsResp>(`accounts-dashboard/views/${accountId}/countries`)
  }

  getTopItems(accountId: string) {
    return this.get<IAccountTopItemsResp>(`accounts-dashboard/${accountId}/top-items`)
  }

  getImpactsLikes(accountId: string) {
    return this.get<IAccountImpactsLikesResp>(`accounts-dashboard/likes/${accountId}/impacts`)
  }

  getProductsViews(accountId: string) {
    return this.get<IAccountProductsViewsResp>(`accounts-dashboard/views/${accountId}/products`)
  }

  getImpactLikes(accountId: string, impactId: string, timeframe: number) {
    return this.get<IAccountImpactLikesResp>(
      `accounts-dashboard/likes/${accountId}/impacts/${impactId}`,
      {
        params: {
          timeframe,
        },
      },
    )
  }

  getProductViews(accountId: string, productId: string, timeframe: number) {
    return this.get<IAccountProductViewsResp>(
      `accounts-dashboard/views/${accountId}/products/${productId}`,
      {
        params: {
          timeframe,
        },
      },
    )
  }
}

export const accountsDashboardService = new AccountsDashboardService()

export default AccountsDashboardService
